module.exports = __webpack_public_path__ + "static/media/carousel-new-3.39633c6c.png";